import * as React from 'react';
import {Typography, Box, TextField, Button} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { GlobalConfig } from '../../../sdk/model';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { configApi } from '../../../adapters/APIExporter';
import { setGlobalConfigDataLoad } from '../../../slices/globalConfigDataLoad';

function AdminConfigs() {
  const [mutableConfig, setMutableConfig] = React.useState<GlobalConfig | undefined>(undefined);
  const [editing, setEditing] = React.useState(false);
  const globalConfig: GlobalConfig = useAppSelector((state) => state.globalConfigDataLoad);
  const dispatch = useDispatch();
  
  React.useEffect(() => {
    setMutableConfig({...globalConfig});
  }, [globalConfig]);
  
  if (!mutableConfig) {
    return <Typography>Loading...</Typography>
  }
  
  function handleChange(event) {
    const {name, value} = event.target;
    const newMutableConfig = {...mutableConfig};
    newMutableConfig[name] = value;
    setMutableConfig(newMutableConfig);
  }
  
  function cancelEdit() {
    setMutableConfig({...globalConfig});
    setEditing(false);
  }
  
  function save() {
    configApi.setGlobalConfig(mutableConfig!).then(() => {
      dispatch(setGlobalConfigDataLoad(mutableConfig));
      setEditing(false);
    })
  }
  
  return <Box>
    <TextField name="currentWeek" label="Current Week: " value={mutableConfig.currentWeek} type="number" onChange={handleChange} disabled={!editing} />
    <TextField name="currentSeason" label="Current Season: " value={mutableConfig.currentSeason} type="number" onChange={handleChange} disabled={!editing} />
    <DatePicker
      label="Next Week Begin Date: "
      value={mutableConfig.nextWeekBeginDate}
      onChange={date => handleChange({ target: { value: date, name: 'nextWeekBeginDate' } })}
      disabled={!editing}
      renderInput={(params) => <TextField {...params} />}
    />
    <br /><br />
    {editing ?
      <Box>
        <Button className='capsized-button' onClick={cancelEdit}>Cancel</Button>
        <Button className='capsized-button' onClick={save}>Save</Button>
      </Box> :
      <Button className='capsized-button' onClick={() => setEditing(true)}>Edit</Button>
    }
  </Box>
}

export default AdminConfigs;
